const root = document.documentElement;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion) {
  root.classList.add('hma-motion-ready');

  const revealSelector = [
    '.hma-manifesto__inner',
    '.hma-section-head',
    '.hma-product-card',
    '.hma-editorial__media',
    '.hma-editorial__copy',
    '.hma-trust__item',
    '.hma-story__intro',
    '.hma-story__portrait',
    '.hma-story__thesis-copy',
    '.hma-story__statement-inner',
    '.hma-story__wide',
    '.hma-story__principles-head',
    '.hma-story__principle',
    '.hma-story__panorama',
    '.hma-story__faith-inner',
    '.hma-story__closing',
    '.hma-contact__hero-copy',
    '.hma-contact__hero-note',
    '.hma-contact__intro',
    '.hma-contact__form-wrap',
    '.hma-contact__closing-inner',
    '.hma-pieces__hero-inner',
    '.hma-pieces__rail',
    '.hma-pieces-card',
    '.hma-pieces__interlude-inner',
    '.hma-pieces__closing-inner'
  ].join(',');

  const prepared = new WeakSet();
  const preparedCampaigns = new WeakSet();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      requestAnimationFrame(() => entry.target.classList.add('is-visible'));
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -3% 0px'
  });

  const campaignObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const campaign = entry.target.closest('.hma-editorial');
      if (campaign) {
        window.setTimeout(() => campaign.classList.add('is-campaign-visible'), 120);
      }
      campaignObserver.unobserve(entry.target);
    });
  }, {
    threshold: 0.16,
    rootMargin: '0px 0px -8% 0px'
  });

  function prepareRevealElements(scope = document) {
    const elements = [];

    if (scope instanceof Element && scope.matches(revealSelector)) elements.push(scope);
    if (scope.querySelectorAll) elements.push(...scope.querySelectorAll(revealSelector));

    elements.forEach((element, index) => {
      if (prepared.has(element)) return;
      prepared.add(element);
      element.classList.add('hma-reveal');

      if (element.matches('.hma-editorial__media, .hma-story__portrait, .hma-story__wide, .hma-story__panorama')) {
        element.classList.add('hma-reveal--media');
      }

      if (element.matches('.hma-product-card')) {
        element.style.setProperty('--hma-reveal-delay', `${(index % 4) * 85}ms`);
      } else if (element.matches('.hma-pieces-card')) {
        element.style.setProperty('--hma-reveal-delay', `${(index % 4) * 70}ms`);
      } else if (element.matches('.hma-trust__item')) {
        element.style.setProperty('--hma-reveal-delay', `${(index % 3) * 90}ms`);
      } else if (element.matches('.hma-story__principle')) {
        element.style.setProperty('--hma-reveal-delay', `${(index % 3) * 80}ms`);
      } else if (element.matches('.hma-contact__hero-note')) {
        element.style.setProperty('--hma-reveal-delay', '130ms');
      } else if (element.matches('.hma-contact__form-wrap')) {
        element.style.setProperty('--hma-reveal-delay', '90ms');
      } else if (element.matches('.hma-pieces__rail')) {
        element.style.setProperty('--hma-reveal-delay', '70ms');
      } else {
        element.style.setProperty('--hma-reveal-delay', '0ms');
      }

      observer.observe(element);
    });

    const campaignMedia = [];
    if (scope instanceof Element && scope.matches('.hma-editorial__media')) campaignMedia.push(scope);
    if (scope.querySelectorAll) campaignMedia.push(...scope.querySelectorAll('.hma-editorial__media'));

    campaignMedia.forEach((media) => {
      if (preparedCampaigns.has(media)) return;
      preparedCampaigns.add(media);
      campaignObserver.observe(media);
    });
  }

  prepareRevealElements(document);

  document.addEventListener('shopify:section:load', (event) => {
    prepareRevealElements(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    prepareRevealElements(document);
  });
}
